import { Fonts } from 'src/com/sixdee/crbtportal/utils/resources/fonts';
import { ButtonCSSStyle, ButtonCSSStyleImpl } from '../../../../toolkit/button/buttoncss';

export interface SetNowButtonCSSStyle extends ButtonCSSStyle
{
    getButtonStyle(): object;
    getButtonText(): object;
}

export class SetNowButtonCSSStyleImpl extends ButtonCSSStyleImpl implements SetNowButtonCSSStyle 
{ 
    getWrapperCSSStyle(): object 
    {
       return {
        position: 'relative', 
        height: '40px', 
        width: '100%', 
        cursor: "default",
        outline:'none'

      };
    }

    getButtonStyle(): object 
    {
       return {
        width:'100%',
        height: '40px',
        float: 'left', 
        border:'none',
        borderRadius: '3px',
        overflow: 'hidden',
        backgroundColor:"#BFDAFFE5",
        cursor: "pointer",
        alignContent: 'center',
        alignItems: "center",
        justifyContent: "center",
        outline:'none'
  
      };
    }

    getButtonText(): object 
    {
        return {
            color:"#033271", 
            fontSize: this.getResources().getFont(Fonts.h8), 
            fontFamily: this.getResources().getFontFamily(), 
            lineHeight: "40px",
            fontWeight:900,
            textAlign: "center",
            cursor: "pointer"
       };
     } 
}


// WEBPACK FOOTER //
// ./src/com/sixdee/crbtportal/ui/components/home/flashmessage/flashmessagecard/flashcardbuttoncss.tsx